import React, { useEffect } from 'react';

    function ExternalRedirectComponent() {
      useEffect(() => {
        // Redirect immediately when the component mounts
        window.location.href = 'https://taylorsiemens.framer.website/work'; 
        // Or for a cleaner history (prevents back button to this component):
         window.location.replace('https://taylorsiemens.framer.website/work');
      }, []); // Empty dependency array ensures it runs only once on mount

      return (
        <div>
          <p>Redirecting to new site...</p>
        </div>
      );
    }

    export default ExternalRedirectComponent;